export default __webpack_public_path__ + "images/f21626870c6714356fdf617cd2c88981-festivals_tablet.webp";